// Neon Quest Legendary Theme - Cyberpunk gaming aesthetic - always dark mode
const neonquestLegendary = {
  id: 'neonquestLegendary',
  name: 'Neon Quest ⚡',
  price: 300,
  main: '#00f2ff',
  light: '#00f2ffb7',
  dark: '#00696f',
  bg: '#12131b',
  darkBg: '#12131b',
  contrastText: '#1a1a2e',
  isSuper: true,
  isDarkTheme: true,
  shape: 'square',
  surfaces: {
    // Light mode (dark-only, fallback)
    lightBg: '#12131b',
    lightPaper: '#1e1f28',
    lightContainer: '#1e1f28',
    lightOnSurface: '#ffffff',
    lightOnSurfaceVariant: 'rgba(255,255,255,0.7)',
    lightOutline: '#ffffff33',
    // Dark mode
    containerLowest: '#12131b',
    containerLow: '#0a0a10',
    container: '#12131b',
    containerHigh: '#1e1f28',
    containerHighest: '#282930',
    bright: '#323338',
    onSurface: '#ffffff',
    onSurfaceVariant: 'rgba(255,255,255,0.7)',
    outline: 'rgba(255,255,255,0.2)',
    outlineVariant: 'rgba(255,255,255,0.08)',
    // Button colors — primary
    primaryContainer: '#00f2ff',
    onPrimaryContainer: '#1a1a2e',
    // Button colors — secondary (outlined)
    secondaryContainer: '#1a2040',
    onSecondaryContainer: '#579ca1',
    // Button colors — secondary (filled)
    secondary: '#00696f',
    onSecondary: '#1a0030',
    secondaryLight: '#00696f',
    onSecondaryLight: '#ffffff',
    // Button colors — inverse
    inverseSurface: '#ffffff',
    onInverseSurface: '#12131b',
    inverseSurfaceLight: '#12131b',
    onInverseSurfaceLight: '#ffffff',
    // Button colors — label/text
    labelColor: '#00f2ff',
    labelColorLight: '#00f2ff',
    // Status colors
    success: '#00ff88',
    successLight: '#74ffbb',
    successDark: '#008844',
    warning: '#ffaa00',
    warningLight: '#ffcc44',
    warningDark: '#cc7700',
    error: '#ff4466',
    errorLight: '#ff7799',
    errorDark: '#cc0033',
  },
  typography: {
    headline: '"Sora", sans-serif',
    body: '"JetBrains Mono", monospace',
    mono: '"JetBrains Mono", monospace',
  },
  animations: {
    avatar: 'glowPulse',
    taskComplete: 'profileEffect',
    completionGlow: true,
    buttonHover: 'sparkle',
    profileEffect: {
      src: "/uploads/profile-effects/uplink-error/effect.json",
      width: 450,
      height: 880,
      scaleToCard: true,
    },
  },
  nameplate: {
    light: {
      src: "/uploads/profile-effects/glitch/bg.json",
      animateFirst: true,
    },
    dark: {
      src: "/uploads/profile-effects/glitch/bg.json",
      animateFirst: true,
    },
  },
  defaultBackground: "/uploads/backgrounds/1779860777266-161705290.png",
  effects: {
    glowColor: '#00f2ff50',
    accentGlow: '#00696f80',
    topGlowBar: true,
  },
  textures: {
    pattern: 'repeating-linear-gradient(0deg, transparent, transparent 2px, rgba(0,242,255,0.03) 2px, rgba(0,242,255,0.03) 4px)',
    patternOpacity: 0.4,
  },
  overlays: {
    scanlines: true,
    scanlineColor: 'rgba(0, 0, 0, 0.19)',
    scanlineGap: '2px',
  },
  modes: {
    light: {
      bg: '#12131b',
      background: 'linear-gradient(160deg, rgba(0, 242, 255, 0.2) 0%, transparent 60%)',
      divider: 'rgba(255,255,255,0.08)',
      textPrimary: '#aa6a0afa',
      textSecondary: '#aa6a0afa',
      cardBg: '#00f2ff42',
      taskBoxShadow: '0px 3px 0px 0px #00f2ff, 0 0 8px rgba(0,242,255,0.3)',
      taskBoxShadowCompleted: '0px 3px 0px 0px #00696f',
      taskBoxShadowHover: '0px 5px 0px 0px #00f2ff, 0 0 16px rgba(0,242,255,0.4)',
      taskBoxShadowActive: '0px 1px 0px 0px #00f2ff',
      taskBorder: '1px solid rgba(0, 242, 255, 0.78)',
      taskCompleteBg: '#00f2ff40',
      taskCompleteText: '#ffffff',
      taskCompleteTextSecondary: 'rgba(255,255,255,0.7)',
      taskPendingText: '#ffffff',
      completedByOtherBg: 'rgba(255,255,255,0.08)',
      overdueBg: 'rgba(230, 81, 0, 0.25)',
      weeklyGoalBg: 'rgba(30,31,40,0.95)',
      weeklyGoalBorder: '1px solid rgba(0, 242, 255, 0.93)',
    },
    dark: {
      bg: '#12131b',
      background: 'linear-gradient(160deg, rgba(0, 242, 255, 0.2) 0%, transparent 60%)',
      divider: 'rgba(255,255,255,0.08)',
      textPrimary: '#aa6a0afa',
      textSecondary: '#aa6a0afa',
      textDisabled: 'rgba(255,255,255,0.4)',
      nameColor: '#00f2ffb7',
      cardBg: '#00f2ff',
      taskBoxShadow: '0px 3px 0px 0px #00f2ff, 0 0 8px rgba(0,242,255,0.3)',
      taskBoxShadowCompleted: '0px 3px 0px 0px #00696f',
      taskBoxShadowHover: '0px 5px 0px 0px #00f2ff, 0 0 16px rgba(0,242,255,0.4)',
      taskBoxShadowActive: '0px 1px 0px 0px #00f2ff',
      taskBorder: '1px solid rgba(0, 242, 255, 0.81)',
      taskCompleteBg: '#00f2ff40',
      taskCompleteText: '#ffffff',
      taskCompleteTextSecondary: 'rgba(255,255,255,0.7)',
      taskPendingText: '#ffffff',
      completedByOtherBg: 'rgba(255,255,255,0.08)',
      overdueBg: 'rgba(230, 81, 0, 0.25)',
      weeklyGoalBg: 'rgba(30,31,40,0.95)',
      weeklyGoalBorder: '1px solid rgba(0, 242, 255, 0.87)',
    },
  },
};

export default neonquestLegendary;
